import { type MetricField, type OrganicStatsResponseDimensionEntry } from "../../../gql-generated/types";
import { funnelAnalysisFieldsWithDimensionsCascadingOrder } from "../../models";
import { DIMENSION_FUNNEL_METRIC_MINIMUM, type DimensionFunnel } from "../../models/dimension-funnel";

import { modifyDimensionFunnelItem } from "./modifyDimensionFunnelItem";

const makeDimensionBreakdownKey = (dimensionBreakdown: string, dimension: string) => {
    const dimensionBreakdownParts = dimensionBreakdown.split("_");
    switch (dimension) {
        case "TOTAL":
            return "TOTAL";
        case "GENDER":
            return dimensionBreakdownParts.at(-1);
        default:
            return dimensionBreakdown;
    }
};

export const mapDimensionFunnel =
    (
        statsListFilteredSorted: OrganicStatsResponseDimensionEntry[],
        statsListTotalSorted: OrganicStatsResponseDimensionEntry[],
        isMapEmpty = true,
        dimension = "",
    ) =>
    (dimensionFunnel: DimensionFunnel): DimensionFunnel => {
        let modifiedFunnel = dimensionFunnel;

        for (let index = 0; index < statsListFilteredSorted.length; index++) {
            const statFiltered = statsListFilteredSorted[index];

            const statTotal = statsListTotalSorted[index];
            const totalValueInt = Number.parseInt(statTotal?.statsList[0]?.value ?? "");

            const firstMetricField: MetricField | null =
                index > 0 ? funnelAnalysisFieldsWithDimensionsCascadingOrder[0] ?? null : null;
            const previousMetricField: MetricField | null =
                index > 0 ? funnelAnalysisFieldsWithDimensionsCascadingOrder[index - 1] ?? null : null;

            const isNotEnough = totalValueInt < DIMENSION_FUNNEL_METRIC_MINIMUM;

            if (statFiltered?.field) {
                for (const { value, dimensionBreakdown } of statFiltered.statsList) {
                    const dimensionBreakdownKey = makeDimensionBreakdownKey(dimensionBreakdown, dimension);

                    // if there is an unknown dimension, we would not have label to render it >> skip
                    if (dimensionBreakdownKey && dimensionFunnel[dimensionBreakdownKey]) {
                        modifiedFunnel = modifyDimensionFunnelItem(
                            modifiedFunnel,
                            dimensionBreakdownKey,
                            statFiltered.field.fieldName,
                            previousMetricField,
                            firstMetricField,
                            value,
                            isMapEmpty,
                            isNotEnough,
                        );
                    }
                }
            }
        }
        return modifiedFunnel;
    };
